import { createSelector } from 'reselect';

import { gettrProviderCodes } from './getters';

export const getProviderCodes = gettrProviderCodes;

export const getProviderCodesClinics = createSelector([ gettrProviderCodes ], res => res?.clinics);

export const getProviderCapabilities = createSelector([ gettrProviderCodes ], res => res?.providerCapabilities);
